





import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { LoadingState } from '@/types';

@Component
export default class Overlay extends Vue {
  @Prop() private showDrawerBoolean!: boolean;
  @Getter private loading!: LoadingState;
  @Mutation private setOverlay!: boolean;

  @Watch('showDrawerBoolean')
  public onShowDrawerBooleanChanged(show: boolean) {
    this.$store.commit('setOverlay', show);
  }

  private hideDrawer() {
    this.showDrawerBoolean = false;
  }
}
